// IANA timezone identifiers for the project form's Timezone picker.
//
// Sourced from the browser's own tzdata via Intl.supportedValuesOf rather
// than a hand-maintained list — that API returns the runtime's canonical set
// of zone names, so this can never drift from what a real environment
// actually supports the way a hardcoded list would after the next tzdata
// update (DST rule changes, renamed zones, etc.).
//
// Falls back to a small set of zones actually relevant to this business
// (an Indonesian mining contractor) plus UTC on the rare browser that lacks
// supportedValuesOf, so the field still works rather than rendering empty.
const FALLBACK_TIMEZONES = ["UTC", "Asia/Jakarta", "Asia/Makassar", "Asia/Jayapura"];

export function listTimezones(): string[] {
  if (typeof Intl.supportedValuesOf === "function") {
    try {
      return Intl.supportedValuesOf("timeZone");
    } catch {
      // Fall through to the static list below.
    }
  }
  return FALLBACK_TIMEZONES;
}
